<template>
    <section class="accordion-container">
        <div class="accordion-title" @click="toggle"><span>{{title}}</span><span><v-icon :name="iconName"/></span></div>
        <div v-show="isOpen" class="accordion-content">
            <div class="accordion-content__block">
                <slot/>
            </div>
        </div>
    </section>
</template>


<script>
    import 'vue-awesome/icons/chevron-down'
    import 'vue-awesome/icons/chevron-up'

    import Icon from 'vue-awesome/components/Icon'

    export default {
        name: 'accordionComponent',
        components: {
            'v-icon': Icon
        },
        props: {
            title: {
                type: String,
            }
        },
        data() {
            return {
                isOpen: false,
            }
        },
        created(){
            this.$parent.addTab(this)
        },
        computed: {
            iconName: function () {
                return this.isOpen ? "chevron-up" : "chevron-down";
            }
        },
        methods: {
            toggle: function () {
                this.isOpen = !this.isOpen;
            }
        }
    }
</script>

<style scoped lang="scss">
    .accordion-container {
        background-color: #EEEEEE;
        font-size: 15px;
        margin-bottom: 10px;

        .accordion-title {
            font-family: "Roboto", sans-serif;
            color:#292929;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-weight: bold;
            cursor: pointer;
            padding: 18px 23px;
            user-select: none;
        }
        .accordion-content {
            border-top: 1px solid #c9c9c9;
            background-color: white;
            padding: 10px 0 30px;
            &__colomn {
                display: inline-block;
                margin-right: 10px;
                .switch-icon {
                    height: 32px;
                    width: 20px;
                    color: rgba(0, 0, 0, 0.63);
                    cursor: pointer;
                    margin-left: 5px;
                    &:hover {
                        color: rgba(0, 0, 0, 0.8)
                    }
                }
            }
            &__block {
                margin-top: 10px;
                .txt-fld {
                    height: 32px;
                    border-radius: 4px;
                }
                label {
                    font-weight: bold;
                    display: block;
                    cursor: default;
                }
                span {
                    cursor: pointer;
                    margin-right: 5px;
                    font-weight: bold;
                    font-size: 14px;
                    &.save-btn {
                        color: #0085ba;
                    }
                    &.delete-btn {
                        color: #cf000f;
                    }
                }
            }
            &__title {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                > span {
                    cursor: default;
                }
                .vue-js-switch {
                    position: relative;
                    font-size: 13px;
                    bottom: 1px;
                    cursor: pointer;
                    .v-switch-input {
                        opacity: 0;
                        position: absolute;
                        width: 1px;
                        height: 1px;
                    }
                    .v-switch-core {
                        position: relative;
                        box-sizing: border-box;
                        outline: 0;
                        margin: 0;
                        transition: border-color .3s, background-color .3s;
                        .v-switch-button {
                            position: absolute;
                            border-radius: 100%;
                        }
                    }
                    .v-switch-label {
                        color: #eee;
                        top: -1px;
                        position: absolute;
                        font-weight: 600;
                    }
                }
            }
            &__row {
                display: flex;
            }
        }
    }


</style>
